import { Link, IconChevronRight16 } from '@stitch-fix/mode-react';
export const SavedItemToastLink = () => <Link endIcon={<IconChevronRight16 />} size="tertiary" variant="inherit" href="/wardrobe/saved-items?&showAvailableItems=true">
    View now
  </Link>;